var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 354,
    height: 356,
    viewBox: "0 0 354 356",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_6336_54152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.224 350.347C346.836 352.855 347.117 356 347.117 356H6.936C6.936 356 7.14642 351.645 5.61902 350.041C4.09161 348.437 0 348.664 0 348.664V6.95724C0 6.95724 3.6702 7.10446 5.1976 5.50046C6.72501 3.89648 6.58734 0 6.58734 0H347.257C347.257 0 347.415 3.28534 348.943 4.88931C350.47 6.49332 354 6.95724 354 6.95724L354 348.664C354 348.664 351.612 347.839 349.224 350.347Z",
    fill: "#2856B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82214 355.121C7.81421 354.686 7.78925 354.129 7.72476 353.528C7.6521 352.851 7.52707 352.096 7.30975 351.39C7.09598 350.696 6.77139 349.976 6.25592 349.435C5.73856 348.891 5.04935 348.545 4.38089 348.317C3.70419 348.086 2.98383 347.954 2.34027 347.877C1.79224 347.813 1.28339 347.786 0.879486 347.777V7.82404C1.23749 7.80637 1.67862 7.77069 2.15451 7.70041C3.29111 7.53256 4.85315 7.13751 5.8345 6.10696C6.80795 5.08472 7.17853 3.45453 7.33704 2.26489C7.40631 1.74475 7.44025 1.26367 7.45636 0.879486H346.462C346.506 1.20352 346.571 1.60263 346.669 2.03668C346.909 3.09738 347.372 4.51541 348.306 5.49582C349.239 6.47537 350.697 7.0444 351.795 7.36835C352.299 7.51678 352.761 7.62329 353.121 7.69604L353.121 347.655C352.904 347.651 352.664 347.66 352.403 347.691C351.313 347.822 349.928 348.332 348.587 349.74C347.251 351.144 346.665 352.721 346.414 353.935C346.32 354.385 346.272 354.789 346.248 355.121H7.82214Z",
    stroke: "#7D99BC",
    strokeWidth: 1.75896
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_6336_54152",
    x: -8.79482,
    y: -8.79482,
    width: 371.59,
    height: 373.59,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.39741
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_6336_54152"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_6336_54152",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchAccount);
export default __webpack_public_path__ + "static/media/switch_account.996f2a3646470c4590712d3fd6823021.svg";
export { ForwardRef as ReactComponent };